


import React from 'react'
import { Container } from 'react-bootstrap'

export default function About() {
    return (
        <Container>

            <h1>About</h1>

            <p className="lead">About the business and the people behind it...</p>

            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam non lacus in nulla pulvinar maximus. Integer fermentum quis ligula vel semper. Quisque sed pharetra nisi. Proin nisi libero, varius at justo nec, tincidunt faucibus massa. Duis elementum enim et mattis varius.
            </p>

        </Container>
    )
}
